<template>
  <form @submit.prevent="save">
    <b-modal
      :visible="visible"
      :title="title"
      @hide="hide"
    >
      <div v-loading="loading">
        <div class="row">
          <div
            v-for="code in languagesCodes"
            :key="code"
            class="col-4"
          >
            <div class="form-group">
              <label>{{ code.toUpperCase() }}</label>
              <input
                v-model="model[code]"
                type="text"
                class="form-control"
                required
                maxlength="100"
              >
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <input
          :value="$t('Save')"
          type="submit"
          class="btn btn-primary"
        >
        <b-button @click="hide">
          {{ $t('Close') }}
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import ColorsMapsService from '../../services/ColorsMapsService';
import Languages from '../Localization/Languages';

export default {
  name: 'AppColorsMapsEditModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    colorMapId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: this.value,
      loading: true,
      model: {},
    };
  },
  computed: {
    title() {
      return `${this.$tc('Colors Maps', 1)} #${this.colorMapId}`;
    },
    languagesCodes() {
      return Languages.codes();
    },
  },
  watch: {
    value(v) {
      if (v === true) {
        this.load();
      }
      this.visible = v;
    },
  },
  methods: {
    load() {
      this.loading = true;
      ColorsMapsService.findById(this.colorMapId).then(data => {
        this.model = data;
        this.loading = false;
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
        this.loading = false;
      });
    },
    hide() {
      this.visible = false;
      this.$emit('input', false);
    },
    save() {
      this.loading = true;
      ColorsMapsService.update(this.colorMapId, this.model).then(() => {
        this.$notifications_success(this.$t('Action', { object: this.$tc('Colors Maps', 1), action: this.$t('saved') }));
        this.loading = false;
        this.$emit('saved');
      }).catch(e => {
        this.$notifications_error(e.message);
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  .marketplaces-control {
    max-height: 70vh;
    overflow: hidden auto;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: .6rem;
        border: $gray-400 1px solid;
        margin-bottom: 5px;
        cursor: pointer;
        overflow: auto;

        div {
          float: left;
        }

        &:hover {
          background-color: $gray-100;
        }
      }
    }

    &__arrow {
      margin-left: 5px;

      &--right {
        margin-left: 0;
        margin-right: 5px;
        float: right !important;
      }
    }
  }
</style>
